__turbopack_context__.v({
  "container": "ExportSettingsMetadata-module__Acr0rG__container",
  "items": "ExportSettingsMetadata-module__Acr0rG__items",
});
